import { aiApi } from '@/api/aiApi';
import useCounterStore from '@/store';
import AuthService from '@/services/auth';

// 模型信息接口
export interface ModalInfo {
    name: string;
    code: string;
}

// 缓存有效期：5分钟
const CACHE_DURATION = 5 * 60 * 1000;

/**
 * 模型服务类
 * 提供模型列表的缓存管理和获取功能
 */
class ModelService {
    /**
     * 获取模型列表（带缓存）
     * @returns Promise<ModalInfo[]>
     */
    async getModelList(): Promise<ModalInfo[]> {
        // 检查用户是否已登录
        if (!AuthService.isAuthenticated()) {
            console.log('用户未登录，无法获取模型列表');
            return [];
        }

        const store = useCounterStore.getState();
        const now = Date.now();
        
        // 检查缓存是否有效
        if (
            store.modalList.length > 0 && 
            store.modalListLastFetch > 0 && 
            (now - store.modalListLastFetch) < CACHE_DURATION
        ) {
            console.log('使用缓存的模型列表');
            return store.modalList;
        }

        try {
            console.log('从服务器获取模型列表...');
            const modelList = await aiApi.conversation.getModal() as ModalInfo[];
            
            if (modelList && modelList.length > 0) {
                // 更新缓存
                store.setModalList(modelList);
                store.setModalListLastFetch(now);
                console.log('模型列表已缓存:', modelList);
                return modelList;
            } else {
                console.warn('获取到空的模型列表');
                return [];
            }
        } catch (error) {
            console.error('获取模型列表失败:', error);
            // 如果请求失败，返回缓存的数据（如果有的话）
            return store.modalList;
        }
    }

    /**
     * 清除模型列表缓存
     */
    clearCache(): void {
        const store = useCounterStore.getState();
        store.setModalList([]);
        store.setModalListLastFetch(0);
        console.log('模型列表缓存已清除');
    }

    /**
     * 强制刷新模型列表
     * @returns Promise<ModalInfo[]>
     */
    async refreshModelList(): Promise<ModalInfo[]> {
        this.clearCache();
        return this.getModelList();
    }
}

// 导出单例实例
export const modelService = new ModelService();
export default modelService;